/* unplugin-vue-components disabled */import { render } from "./wekcome.vue?vue&type=template&id=7590e279"
const script = {}

import exportComponent from "D:\\星网代码\\2018-05-18 路特利\\2022-02-23需求\\DM.LtlApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__